import * as React from 'react';
import { useCookieConsent } from '../../cookie-consent';
import * as facebook from './facebook';
import * as linkedin from './linkedin';
import type { EventKey, Tag } from './types';

const defaultTags: Array<Tag> = [facebook, linkedin];

export function usePixelTracking(tags: Array<Tag> = defaultTags) {
  const { consent } = useCookieConsent();

  React.useEffect(() => {
    tags.forEach((tag) => {
      tag.init({ consent });
    });
  }, [consent]);

  const track = React.useMemo(
    () =>
      function track(event: EventKey) {
        tags.forEach((tag) => {
          tag.track({ event, consent });
        });
      },
    [consent]
  );

  return track;
}
